import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SEO from './SEO';
import { generateGlobalSchema } from '../utils/schemaGenerator';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <SEO schema={generateGlobalSchema()} />
      {/* Navbar spans full browser width */}
      <Navbar />
      {/* Main content area spanning full width (individual pages handle their own constraints) */}
      <main className="flex-grow w-full">
        {children}
      </main>
      {/* Footer spans full browser width */}
      <Footer />
    </div>
  );
};

export default Layout;
